import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_FAVORITES_PAGE: IInventoryPage = {
	'route': '/research/research/favorites',
	'title': 'Design Favorites',
	'uiReference': [
		'Search Favorites',
		'Scroll to top',
		'Refresh',
		'Sorting',
		'Tag or keyword',
		'Search',
		'Tags',
		'Show all',
		'Advanced Options',
		'Advanced filters',
		'Reset filters',
		'Platform',
		'Marketplace',
		'Product',
		'Date Range',
		'Download',
		'Send',
		'Send as Mail',
		'Newest',
		'Oldest',
		'Title',
		'Tag',
		'Copy all ASINs',
		'ASIN Board',
		'Copy All ASINS',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag',
		'Show BSR categories',
		'Show estimated sales history',
		'Show price history',
		'Open design details',
		'Platform:',
		'Category:',
		'ASIN :',
		'N/A',
		'BSR',
		'Sales',
		'Price',
		'Reviews',
		'Bulletpoints and Description',
		'View design',
		'&pound;',
		'&euro;',
		'Oh man, the board seems to be not included in the free version',
		'Open in KW Workbench',
		'Copy to Clipboard'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/favorites/favorites.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/favorites/favorites.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/favorites/favorites.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	],
	'aliases': []
};
